module.exports = __webpack_public_path__ + "img/formbottomleft-shape.b7b573b4.svg";